import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'localDateTime',
  standalone: true
})
export class LocalDateTimePipe implements PipeTransform {
  constructor() {
  }

  transform(value: Date, args?: any): Date {
    return this.GetClientDateTime(value);
  }

  GetClientDateTime(utcDateTime: Date) {
    if (utcDateTime !== undefined && utcDateTime != null) {
      let dated: Date = new Date(utcDateTime);
      let offset = dated.getTimezoneOffset() * (-1);
      dated.setMinutes(dated.getMinutes() + offset);
      utcDateTime = dated;
    }

    return utcDateTime;
  }
}
